import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

const emptyToUndefined = (value: unknown) =>
  value === '' || value === undefined || value === null ? undefined : value

const optionalString = z.preprocess(
  emptyToUndefined,
  z.string().min(1).optional()
)
const optionalUrl = z.preprocess(emptyToUndefined, z.string().url().optional())

const optionalVercelEnv = z.preprocess(emptyToUndefined, z.string().min(1).optional())

export const clientEnv = createEnv({
  clientPrefix: 'NEXT_PUBLIC_',
  client: {
    NEXT_PUBLIC_EVNTTZ_COOKIE_DOMAIN: optionalString,
    NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL: z.string().url(),
    NEXT_PUBLIC_EVNTTZ_API_WS_URL: z.string().url(),
    NEXT_PUBLIC_EVNTTZ_API_AUTH_TOKEN: z.string().min(1),
    NEXT_PUBLIC_EVNTTZ_WEBAPP_BASE_URL: optionalUrl,
    NEXT_PUBLIC_EVNTTZ_GAMIFICATION_BASE_URL: z.string().url(),
    NEXT_PUBLIC_EVNTTZ_SALES_BASE_URL: optionalUrl,
    NEXT_PUBLIC_EVNTTZ_CODES_BASE_URL: z.string().url(),
    NEXT_PUBLIC_EVNTTZ_CHECK_IN_BASE_URL: optionalUrl,
    NEXT_PUBLIC_EVNTTZ_TRANSCRIBE_BASE_URL: optionalUrl,
    NEXT_PUBLIC_EVNTTZ_GTM_ID: optionalString,
    NEXT_PUBLIC_EVNTTZ_FACEBOOK_APP_ID: optionalString,
    NEXT_PUBLIC_EVNTTZ_RECAPTCHA_KEY: optionalString,
    NEXT_PUBLIC_EVNTTZ_GOOGLE_MAPS_API_KEY: optionalString,
    NEXT_PUBLIC_EVNTTZ_SENTRY_DSN: optionalUrl,
    NEXT_PUBLIC_EVNTTZ_POSTHOG_KEY: optionalString,
    NEXT_PUBLIC_VERCEL_ENV: optionalVercelEnv
  },
  runtimeEnv: {
    NEXT_PUBLIC_EVNTTZ_COOKIE_DOMAIN:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_COOKIE_DOMAIN,
    NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_API_WS_URL: import.meta.env.NEXT_PUBLIC_EVNTTZ_API_WS_URL,
    NEXT_PUBLIC_EVNTTZ_API_AUTH_TOKEN:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_API_AUTH_TOKEN,
    NEXT_PUBLIC_EVNTTZ_WEBAPP_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_WEBAPP_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_GAMIFICATION_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_GAMIFICATION_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_SALES_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_SALES_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_CODES_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_CODES_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_CHECK_IN_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_CHECK_IN_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_TRANSCRIBE_BASE_URL:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_TRANSCRIBE_BASE_URL,
    NEXT_PUBLIC_EVNTTZ_GTM_ID: import.meta.env.NEXT_PUBLIC_EVNTTZ_GTM_ID,
    NEXT_PUBLIC_EVNTTZ_FACEBOOK_APP_ID:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_FACEBOOK_APP_ID,
    NEXT_PUBLIC_EVNTTZ_RECAPTCHA_KEY:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_RECAPTCHA_KEY,
    NEXT_PUBLIC_EVNTTZ_GOOGLE_MAPS_API_KEY:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_GOOGLE_MAPS_API_KEY,
    NEXT_PUBLIC_EVNTTZ_SENTRY_DSN: import.meta.env.NEXT_PUBLIC_EVNTTZ_SENTRY_DSN,
    NEXT_PUBLIC_EVNTTZ_POSTHOG_KEY:
      import.meta.env.NEXT_PUBLIC_EVNTTZ_POSTHOG_KEY,
    NEXT_PUBLIC_VERCEL_ENV: import.meta.env.NEXT_PUBLIC_VERCEL_ENV
  },
  emptyStringAsUndefined: true,
  skipValidation: !!import.meta.env.SKIP_ENV_VALIDATION
})

/** Vite client alias — use in new Vite code; Next keeps `@/env`. */
export const env = {
  ...clientEnv,
  NODE_ENV: import.meta.env.MODE as 'development' | 'test' | 'production',
  BUILD_ID: (import.meta.env.VITE_BUILD_SHA as string | undefined) || undefined,
  APP_VERSION: (import.meta.env.VITE_APP_VERSION as string | undefined) || undefined
}
